module.exports = __webpack_public_path__ + "static/img/ico_go_top.e4202c8a.png";